import script from "./TranscriptionFeedbackAction.vue?vue&type=script&setup=true&lang=js"
export * from "./TranscriptionFeedbackAction.vue?vue&type=script&setup=true&lang=js"

import "./TranscriptionFeedbackAction.vue?vue&type=style&index=0&id=ffaea9a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffaea9a0"]])

export default __exports__